import { useEffect, useState } from "react";
import { _deleteDocument } from "../actions/documents";
import { _getPlaces } from "../actions/places";
import { useSnackbar } from "notistack";
import { profileRole, roleRestrictedRoutes } from "../constants/auth";
import { CoordsProps } from "../interfaces";

export const useIsMobileDevice = () => {
    const isMobileDevice = (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i));
    return isMobileDevice ? true : false;
}

export const useProfileRole = () => {
    const getProfileRole = (userRole: any) => {
        const role = Object.entries(profileRole).find((entry: any) => {
            const [key, value] = entry;
            const roleFound = value.some((item: any) => item === userRole);
            if(roleFound) return key;
        });
        return role && role[0];
    }
    return getProfileRole;
};

export const useRoutesRole = () => {
    const getRoutesRole = (route: any, userRole: any) => {
        const role = Object.entries(roleRestrictedRoutes).find((entry: any) => {
            const [key, value] = entry;
            if(userRole === key){
                const roleFound = value.some((item: any) => route.match(item));
                if(roleFound) return key;
            }
        });
        if(role){
            return role[0];
        }else{
            return "";
        }
    }
    return getRoutesRole;
};

export const useDebounce = (value: any, delay: number) => {
    const [debounceValue, setDebounceValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebounceValue(value)
        }, delay);
        return () => {
            clearTimeout(handler)
        }

    }, [value, delay]);
    return debounceValue;
}

export const useOnGetPlaces = () => {
    const [places, setPlaces] = useState<any>({
        fetching: "unknown",
        data: []
    });

    const getPlaces = async (text: string, coords: CoordsProps) => {
        const placesResult = await new Promise((resolve, reject) => {
            setPlaces({...places, fetching: "loading"});
            _getPlaces(text, coords)
            .then((res: any) => resolve(res))
            .catch((reason: any) => reject(reason));
        });
        setPlaces({fetching: "success", data: placesResult ?? []});
    }
    
    return {
        getPlaces,
        places
    }
}

export const useToast = () => {
    const { enqueueSnackbar } = useSnackbar();
    const pushToast = (
        message: string,
        secondParameter?: any
    ) => {
        let content = `message\n${message}`;

        if(secondParameter){
            if(typeof(secondParameter) === "string"){
                content = `title\n${secondParameter}\n${message}`;
            }
        }

        enqueueSnackbar(content, { autoHideDuration: 4000 });
    };

    return pushToast;
};